import { useEffect, useRef, useState } from "react";
import { userState } from "../../interface/MainInterface";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { Box, IconButton, Pagination, PaginationItem, Stack, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef, gridPageCountSelector, gridPageSelector, GridPaginationModel, GridRenderCellParams, GridRowSelectionModel, useGridApiRef, useGridSelector } from "@mui/x-data-grid";
import Toast from "../../utils/Toast";
import PopAddKeyword from "./PopAddKeyword";

interface propsType {
    userState: userState;
  }

const unAuthAPI = new HttpUnAuthApi();

const Setting2 = (props: propsType) => {
    const toastRef: any = useRef();
    const popAddKeywordRef: any = useRef();
    const [isLoading, setIsLoading] = useState(false);

    const [question, setQuestion] = useState("");
    const [categories, setCategories] = useState<any>([]);
    const [showCategory, setShowCategry] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<any>({key: "fashion", value: "패션"});
    const [keywordList, setKeywordList] = useState<any>([]);

    // 키워드 생성 입력란
    const [keywordNameKr, setKeywordNameKr] = useState("");
    const [keywordNameEn, setKeywordNameEn] = useState("");

    let pageSize: number = 10;
    const gridApi = useGridApiRef();
    const [selectedRow, setSelectedRow] = useState<GridRowSelectionModel>([]);
    const [selectedPage, setSelectedPage] = useState<GridPaginationModel>({ pageSize: pageSize, page: 0 });
    
    const [rows, setRows] = useState([]);
    const columns: GridColDef[] = [
        {field: 'name_kr', headerName: '키워드(한글)', headerAlign: "center", align: "center", flex: 1},
        {field: 'name_en', headerName: "키워드(영문)", headerAlign: "center", align: "center", flex: 1.5},
        {field: 'delete_keyword', headerName: "삭제", headerAlign: "center", align: "center", flex: 0.5,
          renderCell: (param: GridRenderCellParams) => {
            return (
              <IconButton
                onClick={() => {
                    delete_category_info(param.row);
                }}
              >
                <Tooltip title="키워드 삭제">
                  <img src="/images/svg-delete.svg" />
                </Tooltip>
              </IconButton>
            )
          }
        }
    ];

    useEffect(() => {
        get_category_list();
        return () => {
            setSelectedPage({ pageSize: pageSize, page: 0 });
        }
    }, []);

    useEffect(() => {
        get_category_info();
        setKeywordNameEn("");
        setKeywordNameKr("");
    }, [selectedCategory]);

    useEffect(() => {
        if (question === "") {
            setRows(keywordList);
        } else {
            const upperQuestion = question.toUpperCase();
            const filteredList = keywordList.filter((item: any) => {
                return item.name_kr.includes(question) || item.name_en.includes(upperQuestion);
            });
            setRows(filteredList);
        }
    }, [keywordList, question]);

    const get_category_list = async () => {
        const param: any = {
          command: "get_category_list",
          pk: "trendreport#category",
          sk: "all",
        };
        const res = await unAuthAPI.post(param);
        if (res.code === "200") {
          setCategories(res.response.category_list);
        } else {
          console.error("[ERROR] get_category_list : ", res.response.error_msg);
        }
    };

    const get_category_info = async () => {
        const param: any = {
            command: "get_category_info",
            category: selectedCategory,
        }
        const res = await unAuthAPI.post(param);
        if (res.code === "200") {
            setKeywordList(res.response.data_list);
        } else {
            console.error("[ERROR] get_category_info : ", res.response.error_msg);
        }
    };

    const delete_category_info = async (keyword_info: any) => {
        if (!window.confirm("해당 키워드를 삭제하시겠습니까?")) return;

        setIsLoading(true);
        const param: any = {
            command: "delete_category_info",
            category: selectedCategory,
            keyword: keyword_info,
        }

        const res = await unAuthAPI.post(param);
        if (res.code === "200") {
            get_category_info();
        } else {
            console.error(res.response.error_msg);
            toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
                vertical: "top",
                horizontal: "center",
            });
        }
        setIsLoading(false);
    };

    const update_category_info = async () => {
        if (keywordNameKr === "" || keywordNameKr === undefined) {
            toastRef.current?.toast("키워드(한글)을 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
            return;
        }
        if (keywordNameEn === "" || keywordNameEn === undefined) {
            toastRef.current?.toast("키워드(영문)을 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
            return;
        }
        if (!window.confirm("키워드를 생성하시겠습니까?")) return;

        setIsLoading(true);
        const param: any = {
            command: "update_category_info",
            category: selectedCategory,
            keyword: {
                name_kr: keywordNameKr,
                name_en: keywordNameEn.toUpperCase(),
            },
        }

        const res = await unAuthAPI.post(param);
        if (res.code === "200") {
            get_category_info();
        } else {
            console.error(res.response.error_msg);
            toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
                vertical: "top",
                horizontal: "center",
            });
        }
        setIsLoading(false);
        setKeywordNameKr("");
        setKeywordNameEn("");
    };

    const selectCategory = (category: any) => {
        setShowCategry(false);
        setSelectedCategory(category);
    }

    const update_keyword = () => {
        popAddKeywordRef.current.open();
    }

    function CustomPagination() {
        const page = useGridSelector(gridApi, gridPageSelector);
        const pageCount = useGridSelector(gridApi, gridPageCountSelector);
        return (
          <Box sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
            <Pagination
              color="primary"
              shape="rounded"
              count={pageCount === 0 ? 1 : pageCount}
              page={page + 1}
              siblingCount={10}
              onChange={(e, v) => gridApi.current.setPage(v - 1)}
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  // next 버튼을 커스터마이즈
                  components={{
                    previous: (props) => (
                      <Stack direction="row" gap={2}>
                        <Typography sx={{ fontWeight: 500, fontSize: "13px", color: '#2A2A2A' }}>이전</Typography>
                        <img src="images/btn-ghost-prev.png" alt="Prev" {...props} />
                      </Stack>
                    ),
                    next: (props) => (
                      <Stack direction="row" gap={2}>
                        <img src="images/btn-ghost-next.png" alt="Next" {...props} />
                        <Typography sx={{ fontWeight: 500, fontSize: "13px", color: '#2A2A2A' }}>다음</Typography>
                      </Stack>
                    ),
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'center',
                    textDecorationLine: item.selected ? 'underline' : 'none',
                    color: item.selected ? '#2A2A2A' : '#B1B1B1',
                    userSelect: 'none',
                    backgroundColor: 'transparent', // 배경 투명
                    border: 'none', // 테두리 없음
                    boxShadow: 'none', // 그림자 없음
                    fontWeight: 500,
                    minWidth: "23px",
                    '&:hover': {
                      backgroundColor: 'transparent', // 호버 시 배경 투명
                    },
                    '&.Mui-selected': {
                      backgroundColor: 'transparent', // 선택된 상태 배경 제거
                      color: '#2A2A2A', // 선택된 상태 색상
                    },
                  }}
                />
              )}
            ></Pagination>
          </Box>
        );
    };

    return (
        <>
        <section id="commWrap">
            <Stack direction="column">
                <Box>
                    <Typography sx={{ fontWeight: 700, fontSize: '20px', marginBottom: 6 }}>카테고리별 키워드 관리</Typography>
                </Box>
                <div className="category-list-wrap" style={{ display: "flex", justifyContent: "space-between"}}>
                    <div className="option-wrap">
                        <Stack direction="row" gap={2}>
                            <div className="category">
                                <div className={showCategory ? "category_select_wrap active" : "category_select_wrap"} >
                                    <ul className="default_option">
                                        <li
                                            onClick={() => {
                                                setShowCategry(!showCategory);
                                            }}
                                        >
                                            {selectedCategory.value}
                                        </li>
                                    </ul>
                                    <ul className="select_ul">
                                        {categories.map((category: any, index: number) => (
                                            <li
                                                key={`category-${index}`}
                                                onClick={() => {
                                                    selectCategory(category);
                                                }}
                                            >
                                                {category.value}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="keyword">
                                <input
                                    style={{ width: "240px" }}
                                    type="text"
                                    placeholder="검색어 입력"
                                    value={question}
                                    onChange={(e) => {
                                        setQuestion(e.target.value);
                                    }}
                                />
                            </div>
                            {/* <div className="keyword">
                                <input
                                    style={{ width: "240px" }}
                                    type="text"
                                    placeholder="키워드 (영문)"
                                    value={keywordNameEn}
                                    onChange={(e) => {
                                        setKeywordNameEn(e.target.value);
                                    }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            update_category_info();
                                        }
                                    }}
                                />
                            </div> */}
                        </Stack>
                    </div>
                    <button
                        style={{ 
                            borderRadius: '22px', 
                            width: '140px', 
                            color: '#2A2A2A', 
                            backgroundColor: "#D0FF00",
                            fontWeight: 600,
                            fontSize: '16px',
                        }}
                        onClick={update_keyword}
                    >
                        키워드 생성
                    </button>
                </div>
                <DataGrid
                    apiRef={gridApi}
                    rows={rows}
                    columns={columns}
                    initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: pageSize,
                        },
                    },
                    }}
                    disableColumnMenu
                    slots={{ pagination: CustomPagination }}
                    hideFooterSelectedRowCount
                    getRowId={(row) => row.name_en}
                    rowSelectionModel={selectedRow}
                    onRowSelectionModelChange={(newRowSelectionModel) => {
                    setSelectedRow(newRowSelectionModel);
                    }}
                    paginationModel={selectedPage}
                    onPaginationModelChange={(newPagenationModel) => {
                    setSelectedPage(newPagenationModel);
                    }}
                    columnHeaderHeight={44}
                    rowHeight={44}
                    sx={{
                    mt: 2,
                    border: 'none',
                    borderRadius: '0px',
                    // height: 44 * 10, // 고정 높이 설정: 8개의 행 + 헤더 높이 + 페이지네이션 높이
                    "& .MuiDataGrid-columnHeaders": { backgroundColor: "#F5F5F5", borderColor: '#000' },
                    "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 700, fontSize: '14px' },
                    "& .MuiDataGrid-footerContainer": { borderTop: 'none' },
                    }}
                />
            </Stack>     
        </section>
        <Toast ref={toastRef} />
        <PopAddKeyword 
            ref={popAddKeywordRef}
            callback={(payload: any) => {}}
        />
        </>
    );
}

export default Setting2;